var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDashboardContext } from '../../DashboardProvider';
var noClick = function () { };
var DashboardTile = function (_a) {
    var title = _a.title, value = _a.value, _b = _a.onClick, onClick = _b === void 0 ? null : _b, _c = _a.className, className = _c === void 0 ? null : _c, _d = _a.titleClassName, titleClassName = _d === void 0 ? null : _d, style = _a.style, _e = _a.children, children = _e === void 0 ? null : _e, _f = _a.onlyTitleClickable, onlyTitleClickable = _f === void 0 ? false : _f;
    var formatMessage = useIntl().formatMessage;
    var editMode = useDashboardContext().editMode;
    var clickable = typeof onClick === 'function';
    var tileContent = (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: classNames('title', titleClassName) }, { children: _jsx("span", { children: typeof title === 'string' ? title : formatMessage(title) }) })), _jsx("div", __assign({ className: "value" }, { children: _jsx("span", { children: value }) })), children] }));
    var clickableTitleTileContent = (_jsxs(_Fragment, { children: [_jsxs("button", __assign({ type: "button", onClick: editMode ? noClick : onClick, style: style, className: "tile" }, { children: [_jsx("div", __assign({ className: classNames('title', titleClassName) }, { children: _jsx("span", { children: typeof title === 'string' ? title : formatMessage(title) }) })), _jsx("div", __assign({ className: "value" }, { children: _jsx("span", { children: value }) }))] })), children] }));
    if (!clickable) {
        return (_jsx("div", __assign({ className: classNames('tile', className, { draggable: editMode }), style: style }, { children: tileContent })));
    }
    if (onlyTitleClickable) {
        return (_jsx("div", __assign({ className: classNames('tile', className, { draggable: editMode }), style: style }, { children: clickableTitleTileContent })));
    }
    return (_jsx("button", __assign({ className: classNames('tile', className, { draggable: editMode }), type: "button", onClick: editMode ? noClick : onClick, style: style }, { children: tileContent })));
};
export default DashboardTile;
